import React, { useState, useEffect, useRef } from "react";
import CalendarTodayIcon from "@mui/icons-material/CalendarToday";
import { Stack, Typography } from "@mui/material";
import "react-date-range/dist/styles.css";
import "react-date-range/dist/theme/default.css";
import { Calendar } from "react-date-range";
import moment from "moment";

export const EndofDayDatePicker = (prop) => {
  const { handleDateChange, date } = prop;

  // open close
  const [open, setOpen] = useState(false);

  // get the target element to toggle
  const refOne = useRef(null);

  useEffect(() => {
    // event listeners
    document.addEventListener("keydown", hideOnEscape, true);
    document.addEventListener("click", hideOnClickOutside, true);
  }, []);

  // hide dropdown on ESC press
  const hideOnEscape = (e) => {
    if (e.key === "Escape") {
      setOpen(false);
    }
  };

  // Hide dropdown on outside click
  const hideOnClickOutside = (e) => {
    if (refOne.current && !refOne.current.contains(e.target)) {
      setOpen(false);
    }
  };
 
  return (
    <div className="calendarWrap">
      <Stack
        sx={{
          flexDirection: "row",
          gap: "8px",
          padding: "8px 12px",
          backgroundColor: "rgba(21, 96, 212, 0.08)",
          borderRadius: "8px",
        }}
        onClick={() => setOpen((open) => !open)}
      >
        <CalendarTodayIcon
          sx={{
            color: "#1560D4",
            width: "24px",
            height: "24px",
          }}
        />
        <Typography color="#1560D4" variant="subtitle2" fontWeight={600}>
          {date
            ? moment(date).format("MMM DD, yyyy")
            : moment().format("MMM DD, yyyy")}
        </Typography>
      </Stack>

      <div ref={refOne}>
        {open && (
          <Calendar
            className="calendarElement"
            date={date ? moment(date).toDate() : new Date()}
            onChange={(e) => {
              handleDateChange(e);
              setOpen(false);
            }}
            maxDate={new Date()}
          />
        )}
      </div>
    </div>
  );
};
